import { Link } from "react-router-dom";
import logoDodoTravelWhite from "../../../images/logoDodoTravelWhite.png";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-col footer-brand">
          <img src={logoDodoTravelWhite} alt="Dodo Travel" className="footer-logo" />
          <p className="footer-tagline">Te ayudamos a volar!</p>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">Navegación</h4>
          <Link to="/backoffice" className="footer-link">BackOffice</Link>
          <Link to="/paquetes" className="footer-link">Paquetes</Link>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">Datos</h4>
          <span className="footer-muted">LEGAJO Nº 20223</span>
          <span className="footer-muted">CUIT 30-71903887-1</span>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {year} Dodo Travel. Todos los derechos reservados.</span>
      </div>
    </footer>
  );
};

export default Footer;
